// extracted by mini-css-extract-plugin
export default {"closeBlock":"BackArrowButton_closeBlock__0gewX"};